import api from './api';

// ============================================================================
// MCP CONFIG (Superadmin)
// ============================================================================

export const getAccountMCPConfig = async (accountId) => {
  const response = await api.get(`/folder/accounts/${accountId}/mcp-config`);
  return response.data;
};

export const updateAccountMCPConfig = async (accountId, config) => {
  const response = await api.put(`/folder/accounts/${accountId}/mcp-config`, config);
  return response.data;
};

export const testMCPConnection = async (accountId) => {
  const response = await api.post(`/folder/accounts/${accountId}/mcp-config/test`);
  return response.data;
};

// ============================================================================
// FOLDER STATUS
// ============================================================================

export const getFolderStatus = async () => {
  const response = await api.get('/folder/status');
  return response.data;
};

export const getMCPConfigs = async () => {
  const response = await api.get('/folder/mcp-configs');
  return response.data;
};

// ============================================================================
// FOLDER BROWSER
// ============================================================================

export const browseFolder = async (path = '/', offset = 0, limit = 100, mcp = 'primary') => {
  const response = await api.get('/folder/browse', { params: { path, offset, limit, mcp } });
  return response.data;
};

export const searchFiles = async (query, limit = 50, offset = 0, mcp = 'primary') => {
  const response = await api.get('/folder/search', { params: { q: query, limit, offset, mcp } });
  return response.data;
};

export const findFilePage = async (path, filename, pageSize = 100, mcp = 'primary') => {
  const response = await api.get('/folder/find-file', { params: { path, filename, page_size: pageSize, mcp } });
  return response.data;
};

export const syncFolder = async (path = '/', mcp = 'primary') => {
  const response = await api.post('/folder/sync-folder', { path, mcp });
  return response.data;
};

export const syncFiles = async (paths, mcp = 'primary') => {
  const response = await api.post('/folder/sync-files', { paths, mcp });
  return response.data;
};

export const getTrackedFiles = async (params = {}) => {
  const response = await api.get('/folder/files', { params });
  return response.data;
};

// ============================================================================
// BATCH ANALYSIS
// ============================================================================

export const startBatchAnalysis = async (fileHashes) => {
  const response = await api.post('/folder/batch-analyze', { file_hashes: fileHashes });
  return response.data;
};

export const previewFilteredBatch = async (filters, mcp = 'primary') => {
  const response = await api.post('/folder/preview-batch', { ...filters, mcp });
  return response.data;
};

export const startFilteredBatch = async (filters, mcp = 'primary') => {
  const response = await api.post('/folder/start-filtered-batch', { ...filters, mcp });
  return response.data;
};

export const getBatchJobs = async (params = {}) => {
  const response = await api.get('/folder/batch-jobs', { params });
  return response.data;
};

export const getBatchJobStatus = async (jobHash) => {
  const response = await api.get(`/folder/batch-jobs/${jobHash}`);
  return response.data;
};

export const cancelBatchJob = async (jobHash) => {
  const response = await api.post(`/folder/batch-jobs/${jobHash}/cancel`);
  return response.data;
};

// ============================================================================
// FILE OPERATIONS
// ============================================================================

export const downloadFile = async (path, mcp = 'primary') => {
  const response = await api.get('/folder/download', {
    params: { path, mcp },
    responseType: 'blob'
  });
  return response.data;
};

export const deleteFile = async (path) => {
  const response = await api.delete('/folder/delete-file', {
    params: { path }
  });
  return response.data;
};

// ============================================================================
// ANALYZE ALL (RECURSIVE)
// ============================================================================

export const analyzeAllRecursive = async (path = '/', excludeAnalyzed = true, mcp = 'primary') => {
  const response = await api.post('/folder/analyze-all', {
    path,
    exclude_analyzed: excludeAnalyzed,
    mcp,
  });
  return response.data;
};

// ============================================================================
// UPLOAD FILE TO MCP
// ============================================================================

export const uploadFileToMCP = async (file, folderPath) => {
  const formData = new FormData();
  formData.append('file', file);
  const fullPath = folderPath.endsWith('/')
    ? `${folderPath}${file.name}`
    : `${folderPath}/${file.name}`;
  const response = await api.post(`/folder/upload-file/${encodeURIComponent(fullPath)}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

